import type { MarketplaceResource } from "../../marketplace";
import type { PriceListItemResource } from "../../price-list-item";
import type { CurrencyResource } from "../../currency";

export enum PriceListCalculateType {
  Absolute = "abs",
  Percent = "percent",
}

export interface PriceListResource {
  id: string;
  gid: string;
  title: string;
  is_active: boolean;
  active_from: string | null;
  active_to: string | null;
  is_net: boolean;
  is_net_show: boolean;
  currency_id: string | null;
  currency?: CurrencyResource;
  calculate_from: CalculationFromEnum;
  calculate_value: string;
  calculate_type: PriceListCalculateType | null;
  is_calculate_round: boolean;
  priceListItems?: PriceListItemResource[];
  marketplaces?: MarketplaceResource[];
}

export enum CalculationFromEnum {
  SellingPrice = "selling_price",
}

export type UpdatePriceListRequestBody = {
  is_active?: boolean;
  active_from?: string | null;
  active_to?: string | null;
  title?: string;
  currency?: string;
  is_net?: boolean;
  is_net_show?: boolean;
  calculation: {
    calculate_value: number;
    is_calculate_percent: boolean;
    is_calculate_round: boolean;
  } | null;
};

export type StorePriceListRequestBody = {
  is_active: boolean;
  active_from?: string | null;
  active_to?: string | null;
  title: string;
  currency: string;
  is_net?: boolean;
  is_net_show?: boolean;
  calculation: {
    calculate_value: number;
    is_calculate_percent: boolean;
    is_calculate_round: boolean;
  } | null;
};
